import styled, { css } from 'styled-components';

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  left: 0;
  z-index: ${p => p.theme.modal.zIndexBackdrop};
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  background: ${p => p.theme.modal.backdrop};
  backdrop-filter: ${p => p.theme.modal.backdropBlur};
`;

export const modalPanelSheet = css`
  background-color: ${p => p.theme.colors.main.white};
  box-sizing: border-box;
  box-shadow: ${p => p.theme.modal.panelShadow};
  border: 1px solid ${p => p.theme.colors.main.grayLight};
  border-radius: ${p => p.theme.modal.radiusSheet};
`;

export const modalPanelDialog = css`
  background-color: ${p => p.theme.colors.main.white};
  box-sizing: border-box;
  box-shadow: ${p => p.theme.modal.panelShadow};
  border: 1px solid ${p => p.theme.colors.main.grayLight};
  border-radius: ${p => p.theme.modal.radiusDialog};
`;
